// Desc: Utility functions

export const contains = (selector, text) => {
  // returns an array of elements that contain the text
  var elements = document.querySelectorAll(selector)
  return [].filter.call(elements, function (element) {
    return RegExp(text).test(element.textContent)
  })
}

export const getNextSiblingWithClass = (element, className) => {
  let sibling = element.nextElementSibling

  while (sibling) {
    if (sibling.classList.contains(className)) {
      return sibling
    }
    sibling = sibling.nextElementSibling
  }

  return null // No matching sibling found
}

export const waitForElement = (selector, containsText = null) => {
  // promise that returns the element when it exists
  return new Promise((resolve, reject) => {
    // Use setInterval to check for the element every 100ms, stop when found or after 5s
    const checkForElement = () => {
      const element = containsText ? contains(selector, containsText) : document.querySelector(selector)

      // If the element exists, stop the interval.
      if ((containsText && element.length > 0) || (!containsText && element)) {
        clearInterval(interval)
        resolve(element)
      }
    }

    // Set the interval.
    let interval = setInterval(checkForElement, 100)

    // After 5 seconds, clear the interval.
    setTimeout(() => {
      clearInterval(interval)
    }, 5000)
  })
}

export const waitForObject = (objectName) => {
  // promise that returns the window object when it exists
  return new Promise((resolve, reject) => {
    // Use setInterval to check for the element every 100ms, stop when found or after 5s
    const checkForObject = () => {
      const object = window[objectName]

      // If the element exists, stop the interval.
      if (object) {
        clearInterval(interval)
        resolve(object)
      }
    }

    // Set the interval.
    let interval = setInterval(checkForObject, 100)

    // After 5 seconds, clear the interval.
    setTimeout(() => {
      clearInterval(interval)
    }, 5000)
  })
}
